import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable, of } from 'rxjs';
import { map, take, timeout, catchError, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    const requiredPermission = route.data['permission'] as string;

    if (!this.authService.isAuthenticated) {
      this.router.navigate(['/login']);
      return false;
    }

    // Check if user has the required permission
    if (requiredPermission) {
      const hasPermission = this.authService.hasPermission(requiredPermission);
      if (!hasPermission) {
        // Redirect to first available route instead of dashboard to avoid redirect loop
        const firstRoute = this.authService.getFirstAvailableRoute();
        this.router.navigate([firstRoute]);
        return false;
      }
    }

    return true;
  }
}
